const styles = theme => ({
  colorPicker: {
    cursor: 'pointer',
  },
});

export default styles;
